import * as types from './types';
import { DELETE_RECIPES, RESET_MENU_STATE } from '../editmenu/types';

export const INITIAL_STATE = {
  recipeCategories: [],
  recipeSources: [],
  recipeGroups: [],
  recipeHACCP: [],
  recipeServingTemp: [],
  mealTypes: [],
  haccps: [],
  haccpTypes: [],
  instructionDescriptions: [],

  selectedRecipesById: {},
  copiedRecipesById: {},
  copiedDays: {},
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.EDIT_MENU_RESET_COPIED:
      return {
        ...state,
        copiedDays: {},
        copiedRecipesById: {},
      };
    case types.EDIT_MENU_COPY:
      return {
        ...state,
        copiedRecipesById: { ...payload.recipes },
        copiedDays: { ...payload.days },
      };
    case types.SET_MEAL_TYPES:
      return {
        ...state,
        mealTypes: payload,
      };
    case types.SET_RECIPE_CATEGORIES:
      return { ...state, recipeCategories: payload };

    case types.SET_RECIPE_SOURCES:
      return { ...state, recipeSources: payload };

    case types.SET_RECIPE_GROUPS:
      return { ...state, recipeGroups: payload };

    case types.SET_RECIPE_HACCP:
      return { ...state, recipeHACCP: payload };

    case types.SET_RECIPE_SERVING_TEMP:
      return { ...state, recipeServingTemp: payload };

    case types.SET_HACCPS:
      return { ...state, haccps: payload };

    case types.SET_HACCP_TYPES:
      return { ...state, haccpTypes: payload };

    case types.SET_RECIPE_INSTRUCTION_DESCRIPTIONS:
      return { ...state, instructionDescriptions: payload };

    case types.SELECT_MENU_ITEMS: {
      const selectedRecipesById = { ...state.selectedRecipesById };

      Object.values(payload).forEach((id) => {
        selectedRecipesById[id] = true;
      });
      return {
        ...state,
        selectedRecipesById,
      };
    }
    case types.SELECT_MENU_ITEM: {
      const selectedRecipesById = state.selectedRecipesById;
      if (selectedRecipesById[payload]) {
        delete selectedRecipesById[payload];
      } else {
        selectedRecipesById[payload] = true;
      }
      return {
        ...state,
        selectedRecipesById: {
          ...selectedRecipesById,
        },
      };
    }

    case types.UNSELECT_MENU_ITEM: {
      const selectedRecipes = { ...state.selectedRecipesById };
      delete selectedRecipes[payload];
      return {
        ...state,
        selectedRecipesById: selectedRecipes,
      };
    }

    case types.UNSELECT_MENU_ITEMS: {
      const selectedRecipes = { ...state.selectedRecipesById };
      payload.forEach((key) => {
        delete selectedRecipes[key];
      });
      return {
        ...state,
        selectedRecipesById: selectedRecipes,
      };
    }
    case DELETE_RECIPES:
    case RESET_MENU_STATE:
    case types.CLEAR_SELECTION:
      return {
        ...state,
        selectedRecipesById: {},
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/managemenu/state/common/reducer.js